// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QqhT9","type":"styles_type__2g6G0","choices":"styles_choices__3kbfG"};